/* eslint-disDigitalAssetsable react/jsx-no-constructed-context-values */
import { createContext } from 'react';

const WalletContext = createContext({});

export default WalletContext;
